import Layout from '@/layout'
const route = {
  path: '/accountManagement',
  component: Layout,
  // redirect: '/accountManagement/index',
  alwaysShow: true, // will always show the root menu
  name: 'messageSubscription',
  meta: {
    title: '公众号配置回复信息',
    icon: 'WOAC',
    roles: [
      'wechat_official_account.config'
    ]
  },
  children: [
    {
      path: '/reportAccountManagement/index',
      component: () => import('@/views/reportAccountManagement/index.vue'),
      name: 'reportAccountManagement',
      meta: {
        title: '公众号配置回复信息',
        roles: [
          'wechat_official_account.config.reply_info'
        ]
      }
    }
  ]
}

export default route
